/**
 * The three things a plan can include. Kept free of React and icons so the
 * edge functions can import it too (the Stripe catalogue sync validates a
 * tier's `features` metadata against this list).
 */
export const FEATURE_KEYS = ['image', 'video', 'iris'] as const

export type FeatureKey = (typeof FEATURE_KEYS)[number]

export type Features = Partial<Record<FeatureKey, boolean>>
